import { useEffect, Component } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import StatesTicker from "@/components/site/StatesTicker";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import ProviderGuide from "@/components/site/ProviderGuide";
import News from "@/components/site/News";
import BeforeAfter from "@/components/site/BeforeAfter";
import Reviews from "@/components/site/Reviews";
import Faq from "@/components/site/Faq";
import Team from "@/components/site/Team";
import Beyond from "@/components/site/Beyond";
import Accreditations from "@/components/site/Accreditations";
import Footer from "@/components/site/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream text-espresso p-8">
          <p className="font-display text-2xl">Something went wrong — please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-cream text-espresso">
      <Navbar />
      <StatesTicker />
      <main>
        <Hero />
        <About />
        <Process />
        <ProviderGuide />
        <News />
        <BeforeAfter />
        <Reviews />
        <Faq />
        <Team />
        <Beyond />
        <Accreditations />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Site />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
